// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultButton_root__s0qbd","root__inner":"DefaultButton_root__inner__iGefc","fill":"DefaultButton_fill__0AcCe"};